import type { DesktopAuthorizeParams } from '../types/desktop-auth.type';

export const desktopAuthKeys = {
  all: ['desktopAuth'] as const,
  preview: (p: DesktopAuthorizeParams) =>
    ['desktopAuth', 'preview', p.clientId, p.redirectUri, p.codeChallenge] as const,
};
